import { Component, computed, input, output } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  offerHasDiscount,
  offerHasGiftcard,
} from '@innogy/become-a-customer/shared';
import {
  ConsumptionValuesVM,
  Offer,
  type OfferOverview,
} from '@innogy/become-a-customer/shared/interfaces';
import { getSkeletonMaskFromRendering } from '@legacy/common-ui-shared';

@Component({
  template: ``,
})
export class BaseOrderOverviewComponent {
  readonly rendering = input<InnogyComponentRendering>();
  readonly offer = input<Offer>();
  readonly consumptionValuesVM = input<ConsumptionValuesVM>();
  public readonly electricityOverview = input<OfferOverview>();
  public readonly gasOverview = input<OfferOverview>();
  public readonly durationTitle = input<string>();

  showTariffs = output<Offer>();

  readonly skeletonLoaderMask = computed(() =>
    getSkeletonMaskFromRendering(this.rendering())
  );
  readonly hasDiscount = computed(() => offerHasDiscount(this.offer()));
  readonly hasGiftcard = computed(() => offerHasGiftcard(this.offer()));
}
